module.exports = __webpack_public_path__ + "img/智能运维.55bf089f.jpg";